import { ref, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

const INITIAL_RECORDATORIO = {
    nombre: '',
    email: '',
    notificaciones: false
};

export function useRecordatorioEvento() {
    // Keys are declared up front: Vue 2 cannot track properties added to a
    // plain object after it becomes reactive.
    const recordatorio = ref({ ...INITIAL_RECORDATORIO });

    const captchaToken = ref(null);
    const loading = ref(false);
    const sitekey = process.env.VUE_APP_CLOUDFLARE_SITE_KEY;

    const canSubmit = computed(() => !!captchaToken.value && !loading.value);

    const onCaptchaVerified = token => {
        captchaToken.value = token;
    };

    /**
     * Turnstile tokens expire while the user is still typing, and the widget
     * also reports hard errors. Both must invalidate the stored token, or
     * canSubmit would stay true and the form would submit a stale token.
     */
    const onCaptchaInvalid = () => {
        captchaToken.value = null;
    };

    const enviarRecordatorio = async eventoId => {
        if (!canSubmit.value) return { ok: false };

        loading.value = true;

        const payload = {
            evento_id: eventoId,
            ...recordatorio.value,
            captchaToken: captchaToken.value
        };

        try {
            await store.dispatch(config.getVuexAlias('front.recordatorios.crear'), payload);
            return { ok: true };
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[useRecordatorioEvento] Error al enviar el recordatorio:', error);
            }
            return { ok: false };
        } finally {
            loading.value = false;
        }
    };

    const resetRecordatorio = () => {
        recordatorio.value = { ...INITIAL_RECORDATORIO };
        captchaToken.value = null;
    };

    return {
        recordatorio,
        captchaToken,
        loading,
        sitekey,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        enviarRecordatorio,
        resetRecordatorio
    };
}
